import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PSDatosGeneralesModel } from '../models/ps-datos-generales-model';
import { Observable } from 'rxjs';
import { LookupData } from '../models/lookup';
import { InformeService } from './informe.service';

@Injectable({
  providedIn: 'root'
})
export class PsDatosGeneralesService {

  myAppUrl: string;

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string, private _informeService: InformeService) {
    this.myAppUrl = baseUrl;
  }

  getAll(importe: string = '', search: string = '', clienteId: string = '', sectorId: string = '') {
    let params = new HttpParams()
      .set('Importe', importe)
      .set('PalabraClave', search)
      .set('ClienteID', clienteId)
      .set('SectorID', sectorId);

    return this._http.get(`${ this.myAppUrl }api/PS_DatosGenerales/`, {params});
  }

  getById(id: number) {
    return this._http.get(`${ this.myAppUrl }api/PS_DatosGenerales/${id}`);
  }

  post(item: PSDatosGeneralesModel) {
    return this._http.post<PSDatosGeneralesModel>(`${ this.myAppUrl }api/PS_DatosGenerales`, item);
  }

  put(id: number, item: PSDatosGeneralesModel): Observable<any> {
    return this._http.put(`${ this.myAppUrl }api/PS_DatosGenerales/${id}`, item);
  }

  getTipoNormativaList() {
    return this._http.get(`${ this.myAppUrl }api/PS_DatosGenerales/TipoNormativa`);
  }

  getSectorList() {
    return this._http.get(`${ this.myAppUrl }api/PS_DatosGenerales/OpcionesSector`);
  }

  getPSLookup(searchTerm: string): Observable<LookupData> {
    return this._http.get<LookupData>(this.myAppUrl + 'api/PS_DatosGenerales/Lookup?k=' + searchTerm);
  }

  getPSLookupId(id: number): Observable<LookupData> {
    return this._http.get<LookupData>(this.myAppUrl + 'api/PS_DatosGenerales/Lookup/' + id.toString());
  }

  getPsEstados() {
    return this._http.get(`${ this.myAppUrl }api/PS_DatosGenerales/Estados`);
  }

  getPSExcel() {
    let url = `${this.myAppUrl}api/PS_DatosGenerales/Excel`;
    this._informeService.downloadFromApiGet(url, "application/octet-stream", "ProyectoSignificativo.xlsx")
    // return this._http.get(`${this.myAppUrl}api/Informe/generarInforme1`)
  }

  getLastDttmExpediente(idps: number) {
    return this._http.get(`${ this.myAppUrl }api/PS_DatosGenerales/GetFechaExpediente/${idps}`);
  }

}
